import axios from 'axios'

async function send_application(dispatch,data,token,setOpen,setMessage,setResponse,setResponses,setHasStarted,setHasEnded,setRecentQuestion,setIndex,setSubmitting){

    setSubmitting(true)

    console.log(data)

      const sendApp = await axios.post(`${process.env.REACT_APP_SERVER_AUTH_URL}send-application/`,data,{
        headers:{
            "Content-Type":"application/json",
            "Authorization":`Bear ${token}`
            }
    }).catch(err=>{
        setMessage("connection error,try later")
        setOpen(true)
        setSubmitting(false)
      })

    if (sendApp?.status == 200 && sendApp?.data.success == true) {
      // console.log(sendApp?.data)
        if (sendApp?.data?.hasEnded) {
            setHasEnded(true)
            setHasStarted(false)
            setMessage(sendApp?.data?.message)
            setOpen(true)
        } else {
            setResponse("")
            setResponses([])
            setIndex(sendApp?.data?.index)
            setRecentQuestion(sendApp?.data?.data)
        }
        setSubmitting(false)
    }else{
      setSubmitting(false)
      setMessage(sendApp?.data?.message)
      setOpen(true)
    }

}

export default send_application